<div class="container max-w-180">
  <div
    class="left"
    [style.width]="`${labelWidthPercentage()}%`"
  >
    <div class="row">
      @if (title()) {
        <span class="side labelContainer text-xs">
          @if (required()) {
            <span id="required">*</span>
          }
          {{ title() }}
        </span>
      }
    </div>
    <div class="row inputField">
      <div
        class="labelContainer side"
        [style.width]="`${labelWidthPercentage()}%`"
      >
        @if (required()) {
          <span id="required">*</span>
        } @else {
          <span [style]="{ width: '23px' }"></span>
        }

        <span class="text-xs">Latitude</span>
      </div>
    </div>
    <div class="row inputField">
      <div
        class="labelContainer side"
        [style.width]="`${labelWidthPercentage()}%`"
      >
        @if (required()) {
          <span id="required">*</span>
        } @else {
          <span [style]="{ width: '23px' }"></span>
        }

        <span class="text-xs">Longitude</span>
      </div>
    </div>
  </div>
  <div
    class="right"
    data-ping-host
  >
    <div class="row">
      <div class="col labelContainer top"><span>Degrees</span></div>
      <div class="col labelContainer top"><span>Minutes</span></div>
      <div class="col labelContainer top"><span>Seconds</span></div>
      <div class="col"></div>
    </div>
    <div class="row border-b-2 border-solid border-[#4f565e]">
      <div class="col">
        <p-inputnumber
          [inputStyleClass]="'!rounded-none !rounded-tl-lg !border-r-0 !border-b-1'"
          [id]="`${id()}-latDegrees`"
          [name]="`${id()}-latDegrees`"
          [required]="required()"
          [min]="0"
          [max]="90"
          (onFocus)="fieldTouched()"
          [ngModel]="editableLatLng()?.latDegrees"
          (ngModelChange)="updateLatLng({ latDegrees: $event })"
        />
      </div>
      <div class="col">
        <p-inputnumber
          [id]="`${id()}-latMinutes`"
          [name]="`${id()}-latMinutes`"
          [required]="required()"
          [min]="0"
          [max]="60"
          (onFocus)="fieldTouched()"
          [ngModel]="editableLatLng()?.latMinutes"
          (ngModelChange)="updateLatLng({ latMinutes: $event })"
        />
      </div>
      <div class="col">
        <p-inputnumber
          [id]="`${id()}-latSeconds`"
          [name]="`${id()}-latSeconds`"
          [required]="required()"
          [min]="0"
          [max]="60"
          (onFocus)="fieldTouched()"
          [ngModel]="editableLatLng()?.latSeconds"
          (ngModelChange)="updateLatLng({ latSeconds: $event })"
        />
      </div>
      <div class="col">
        <p-select
          #select
          [styleClass]="'!rounded-none !rounded-tr-lg !border-l-0'"
          [id]="`${id()}-latDirection`"
          [name]="`${id()}-latDirection`"
          [required]="required()"
          (onFocus)="fieldTouched()"
          [options]="LAT_OPTIONS"
          [ngModel]="editableLatLng()?.latDirection"
          (ngModelChange)="updateLatLng({ latDirection: $event })"
          optionLabel="name"
          placeholder=""
        />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <p-inputnumber
          [inputStyleClass]="'!rounded-none !rounded-bl-lg !border-r-0 !border-t-0'"
          [id]="`${id()}-longDegrees`"
          [name]="`${id()}-longDegrees`"
          [required]="required()"
          [min]="0"
          [max]="180"
          (onFocus)="fieldTouched()"
          [ngModel]="editableLatLng()?.longDegrees"
          (ngModelChange)="updateLatLng({ longDegrees: $event })"
        />
      </div>
      <div class="col">
        <p-inputnumber
          [inputStyleClass]="'!border-t-0'"
          [id]="`${id()}-longMinutes`"
          [name]="`${id()}-longMinutes`"
          [required]="required()"
          [min]="0"
          [max]="60"
          (onFocus)="fieldTouched()"
          [ngModel]="editableLatLng()?.longMinutes"
          (ngModelChange)="updateLatLng({ longMinutes: $event })"
        />
      </div>
      <div class="col">
        <p-inputnumber
          [inputStyleClass]="'!border-t-0'"
          [id]="`${id()}-longSeconds`"
          [name]="`${id()}-longSeconds`"
          [required]="required()"
          [min]="0"
          [max]="60"
          (onFocus)="fieldTouched()"
          [ngModel]="editableLatLng()?.longSeconds"
          (ngModelChange)="updateLatLng({ longSeconds: $event })"
        />
      </div>
      <div class="col">
        <p-select
          #select
          [styleClass]="'!rounded-none !rounded-br-lg !border-l-0 !border-t-0'"
          [id]="`${id()}-longDirection`"
          [name]="`${id()}-longDirection`"
          [required]="required()"
          (onFocus)="fieldTouched()"
          [filter]="false"
          [options]="LONG_OPTIONS"
          [ngModel]="editableLatLng()?.longDirection"
          (ngModelChange)="updateLatLng({ longDirection: $event })"
          optionLabel="name"
        />
      </div>
    </div>
  </div>
</div>
